import { atom } from "jotai";

import { DiningBookingWizardDataAtom } from "@/features/BookingWizard/DiningBookingWizard/atoms/stores";
import { DiningBookingWizard } from "@/features/BookingWizard/DiningBookingWizard/types";

export const updateDiningOccasionTags = atom(
  null,
  (
    get,
    set,
    tags: DiningBookingWizard.DiningBookingWizardData["occasionTags"]
  ) => {
    const diningData = get(DiningBookingWizardDataAtom);
    if (!diningData) {
      return;
    }

    set(DiningBookingWizardDataAtom, {
      ...diningData,
      occasionTags: [...tags],
    });
  }
);
